<script>
import Vue from 'vue'
export default {
  name: 'GeneralTitle',
  render() {
    return (
      <div style="border-left: 4px solid #3a7fbc; color: #3a7fbc; padding-left: 8px; margin-bottom: 8px; margin-top: 8px">
        {this.$slots.default}
      </div>
    )
  },
}
</script>